import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicCameraModelsList } from '~/swr-hooks/filters/usePublicCameraModelsList';

type PublicCameraModelsSelectProps = {
  boardId: string | undefined;
  make: string | undefined;
} & BaseStringSelectProps;

export const PublicCameraModelsSelect = memo(({ boardId, make, ...props }: PublicCameraModelsSelectProps) => {
  const { shortId } = useShortIdContext();
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicCameraModelsList({
    search: debouncedSearchValue,
    shortId,
    boardId,
    make,
  });

  return (
    <StringSelect
      id="camera-model"
      placeholder="Search for model"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicCameraModelsSelect.displayName = 'PublicCameraModelsSelect';
